var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"20px"}},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"22px","float":"left"}},[_vm._v("全国大学生态环境管理科研创新大赛平台使用说明")]),_vm._v(" "),_c('p',{staticStyle:{"height":"30px"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"markdown-body",domProps:{"innerHTML":_vm._s(_vm.html)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d95cf49e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/Admin/Instruction.vue
// module id = null
// module chunks = 